export type SocialId = 'x' | 'telegram' | 'wechat' | 'discord' | 'github' | 'keybase' | 'steam';

export type Social = {
  id: SocialId;
  label: string;
  handle: string;
  href?: string;
  iconClass: string;
  accent: string;
  qrValue?: string;
  qrImageFile?: string;
  copyValue?: string;
  rel?: string;
};

export const socials: readonly Social[] = [
  {
    id: 'x',
    label: 'X',
    handle: '@Yangff1',
    href: 'https://x.com/Yangff1',
    iconClass: 'fa-brands fa-x-twitter',
    accent: '#f5f7fb',
    qrValue: 'https://x.com/Yangff1',
    rel: 'me noopener noreferrer',
  },
  {
    id: 'telegram',
    label: 'Telegram',
    handle: '@realYangff',
    href: 'https://t.me/realYangff',
    iconClass: 'fa-brands fa-telegram',
    accent: '#34b7f1',
    qrValue: 'https://t.me/realYangff',
    rel: 'me noopener noreferrer',
  },
  {
    id: 'wechat',
    label: 'WeChat',
    handle: 'Yang_F_F',
    iconClass: 'fa-brands fa-weixin',
    accent: '#35d06f',
    qrValue: 'https://u.wechat.com/kLWS8DX1IZV9ur6PMrqJ4kQ?s=4',
    qrImageFile: 'assets/wechat-qr.png',
    copyValue: 'Yang_F_F',
  },
  {
    id: 'discord',
    label: 'Discord',
    handle: 'yangff',
    href: 'https://discord.com/users/351358935820795906',
    iconClass: 'fa-brands fa-discord',
    accent: '#8a96ff',
    qrValue: 'https://discord.com/users/351358935820795906',
    copyValue: 'yangff',
    rel: 'noopener noreferrer',
  },
  {
    id: 'github',
    label: 'GitHub',
    handle: 'yangff',
    href: 'https://github.com/yangff',
    iconClass: 'fa-brands fa-github',
    accent: '#f7c75b',
    qrValue: 'https://github.com/yangff',
    rel: 'me noopener noreferrer',
  },
  {
    id: 'keybase',
    label: 'Keybase',
    handle: 'yangff',
    href: 'https://keybase.io/yangff',
    iconClass: 'fa-brands fa-keybase',
    accent: '#ff7657',
    qrValue: 'https://keybase.io/yangff',
    rel: 'me noopener noreferrer',
  },
  {
    id: 'steam',
    label: 'Steam',
    handle: 'yangff',
    href: 'https://steamcommunity.com/id/yangff',
    iconClass: 'fa-brands fa-steam',
    accent: '#66c0f4',
    qrValue: 'https://steamcommunity.com/id/yangff',
    rel: 'me noopener noreferrer',
  },
];